@if (isActive()) {
    <div class="form-group mb-10">
        <div class="col-xs-5 custom-border-wrapper">
            <button
                class="btn btn-action custom-border-btn"
                [tooltip]="'control_custom_radius_toolip' | translate"
                placement="top"
                [class.active]="isIndependentBorders()"
                (click)="toggleIndependentBorders()"
            >
                <img src="./assets/img/websites/lpc-border-icon.svg" />
            </button>
            <!-- placeholder to mix borders -->
            @if (isIndependentBorders()) {
                <div class="border-width-input">
                    <input class="form-control" value="Mix" disabled />
                </div>
            }
            <!-- placeholder to mix borders end -->
            @if (!isIndependentBorders()) {
                <sp-input-num
                    class="border-width-input"
                    [min]="0"
                    [max]="500"
                    [value]="borderForm.borderTopWidth().value()"
                    (valueChange)="setBorderWidth($event, EBorderSide.all)"
                />
            }
        </div>
        <div class="col-xs-5">
            <!-- placeholder to mix borders -->
            @if (isIndependentBorders()) {
                <select class="form-control disabled">
                    <option>Mix</option>
                </select>
            }
            <!-- placeholder to mix borders end -->
            @if (!isIndependentBorders()) {
                <select class="form-control" (change)="setBorderStyle($any($event.target).value, EBorderSide.all)">
                    <option
                        [value]="lineStyle.SOLID"
                        [selected]="borderForm.borderTopStyle().value() === lineStyle.SOLID"
                    >
                        {{ "control_solid" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DASHED"
                        [selected]="borderForm.borderTopStyle().value() === lineStyle.DASHED"
                    >
                        {{ "control_dashed" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DOTTED"
                        [selected]="borderForm.borderTopStyle().value() === lineStyle.DOTTED"
                    >
                        {{ "control_dotted" | translate }}
                    </option>
                </select>
            }
        </div>
        <div class="col-xs-2">
            <!-- placeholder to mix borders -->
            @if (isIndependentBorders()) {
                <sp-color-picker class="disabled" [color]="'#000'" />
            }
            <!-- placeholder to mix borders end -->
            @if (!isIndependentBorders()) {
                <sp-color-picker
                    [color]="borderForm.borderTopColor().value()"
                    (colorChangeEvent)="setBorderColor($event, EBorderSide.all)"
                    [hideGradient]="true"
                    [colorsPreset]="selectedThemeColors()"
                />
            }
        </div>
    </div>
    @if (isIndependentBorders()) {
        <div class="form-group mb-10">
            <div class="col-xs-5">
                <sp-input-num
                    prefixImgUrl="./assets/img/websites/lpc-border-top-icon.svg"
                    [min]="0"
                    [max]="500"
                    [value]="borderForm.borderTopWidth().value()"
                    (valueChange)="setBorderWidth($event, EBorderSide.top)"
                />
            </div>
            <div class="col-xs-7 combined-border-col">
                <select class="form-control" (change)="setBorderStyle($any($event.target).value, EBorderSide.top)">
                    <option
                        [value]="lineStyle.SOLID"
                        [selected]="borderForm.borderTopStyle().value() === lineStyle.SOLID"
                    >
                        {{ "control_solid" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DASHED"
                        [selected]="borderForm.borderTopStyle().value() === lineStyle.DASHED"
                    >
                        {{ "control_dashed" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DOTTED"
                        [selected]="borderForm.borderTopStyle().value() === lineStyle.DOTTED"
                    >
                        {{ "control_dotted" | translate }}
                    </option>
                </select>
                <sp-color-picker
                    [color]="borderForm.borderTopColor().value()"
                    (colorChangeEvent)="setBorderColor($event, EBorderSide.top)"
                    [hideGradient]="true"
                    [colorsPreset]="selectedThemeColors()"
                />
            </div>
        </div>
        <div class="form-group mb-10">
            <div class="col-xs-5">
                <sp-input-num
                    prefixImgUrl="./assets/img/websites/lpc-border-right-icon.svg"
                    [min]="0"
                    [max]="500"
                    [value]="borderForm.borderRightWidth().value()"
                    (valueChange)="setBorderWidth($event, EBorderSide.right)"
                />
            </div>
            <div class="col-xs-7 combined-border-col">
                <select class="form-control" (change)="setBorderStyle($any($event.target).value, EBorderSide.right)">
                    <option
                        [value]="lineStyle.SOLID"
                        [selected]="borderForm.borderRightStyle().value() === lineStyle.SOLID"
                    >
                        {{ "control_solid" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DASHED"
                        [selected]="borderForm.borderRightStyle().value() === lineStyle.DASHED"
                    >
                        {{ "control_dashed" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DOTTED"
                        [selected]="borderForm.borderRightStyle().value() === lineStyle.DOTTED"
                    >
                        {{ "control_dotted" | translate }}
                    </option>
                </select>
                <sp-color-picker
                    [color]="borderForm.borderRightColor().value()"
                    (colorChangeEvent)="setBorderColor($event, EBorderSide.right)"
                    [hideGradient]="true"
                    [colorsPreset]="selectedThemeColors()"
                />
            </div>
        </div>
        <div class="form-group mb-10">
            <div class="col-xs-5">
                <sp-input-num
                    prefixImgUrl="./assets/img/websites/lpc-border-bottom-icon.svg"
                    [min]="0"
                    [max]="500"
                    [value]="borderForm.borderBottomWidth().value()"
                    (valueChange)="setBorderWidth($event, EBorderSide.bottom)"
                />
            </div>
            <div class="col-xs-7 combined-border-col">
                <select class="form-control" (change)="setBorderStyle($any($event.target).value, EBorderSide.bottom)">
                    <option
                        [value]="lineStyle.SOLID"
                        [selected]="borderForm.borderBottomStyle().value() === lineStyle.SOLID"
                    >
                        {{ "control_solid" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DASHED"
                        [selected]="borderForm.borderBottomStyle().value() === lineStyle.DASHED"
                    >
                        {{ "control_dashed" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DOTTED"
                        [selected]="borderForm.borderBottomStyle().value() === lineStyle.DOTTED"
                    >
                        {{ "control_dotted" | translate }}
                    </option>
                </select>
                <sp-color-picker
                    [color]="borderForm.borderBottomColor().value()"
                    (colorChangeEvent)="setBorderColor($event, EBorderSide.bottom)"
                    [hideGradient]="true"
                    [colorsPreset]="selectedThemeColors()"
                />
            </div>
        </div>
        <div class="form-group mb-0">
            <div class="col-xs-5">
                <sp-input-num
                    prefixImgUrl="./assets/img/websites/lpc-border-left-icon.svg"
                    [min]="0"
                    [max]="500"
                    [value]="borderForm.borderLeftWidth().value()"
                    (valueChange)="setBorderWidth($event, EBorderSide.left)"
                />
            </div>
            <div class="col-xs-7 combined-border-col">
                <select class="form-control" (change)="setBorderStyle($any($event.target).value, EBorderSide.left)">
                    <option
                        [value]="lineStyle.SOLID"
                        [selected]="borderForm.borderLeftStyle().value() === lineStyle.SOLID"
                    >
                        {{ "control_solid" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DASHED"
                        [selected]="borderForm.borderLeftStyle().value() === lineStyle.DASHED"
                    >
                        {{ "control_dashed" | translate }}
                    </option>
                    <option
                        [value]="lineStyle.DOTTED"
                        [selected]="borderForm.borderLeftStyle().value() === lineStyle.DOTTED"
                    >
                        {{ "control_dotted" | translate }}
                    </option>
                </select>
                <sp-color-picker
                    [color]="borderForm.borderLeftColor().value()"
                    (colorChangeEvent)="setBorderColor($event, EBorderSide.left)"
                    [hideGradient]="true"
                    [colorsPreset]="selectedThemeColors()"
                />
            </div>
        </div>
    }
}
